/*
 * ET - Video Story (sections/et-video-story.liquid)
 * The still shows until the play button is used. Nothing of the player loads before that click: a Shopify video
 * sits in a hidden wrapper with preload="none", and a YouTube / Vimeo iframe is only built on click from the
 * data-video-src on the frame. One delegated listener covers every section on the page and every
 * section the theme editor re-renders; shopify:section:load resets a frame back to its still.
 */
(function () {
  'use strict';

  var FRAME = '[data-et-video-story]';
  var PLAY = '[data-et-video-story-play]';
  var ACTIVE = 'data-et-video-story-active';

  function playNative(frame) {
    var player = frame.querySelector('[data-et-video-story-player]');
    var video = player && player.querySelector('video');
    if (!video) return false;

    player.hidden = false;

    var started = video.play();
    if (started && typeof started.catch === 'function') {
      started.catch(function () {
        /* Autoplay was refused (no gesture credit); the native controls are visible, so the visitor can start it. */
      });
    }

    return true;
  }

  function playEmbed(frame) {
    var src = frame.getAttribute('data-video-src');
    if (!src) return false;

    var iframe = document.createElement('iframe');
    iframe.className = 'et-video-story__embed';
    iframe.src = src;
    iframe.title = frame.getAttribute('data-video-title') || '';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', 'allowfullscreen');
    iframe.setAttribute('loading', 'lazy');
    frame.appendChild(iframe);

    return true;
  }

  function activate(frame) {
    if (!frame || frame.hasAttribute(ACTIVE)) return;

    var played = frame.getAttribute('data-video-type') === 'native' ? playNative(frame) : playEmbed(frame);
    if (played) frame.setAttribute(ACTIVE, '');
  }

  function reset(root) {
    var frames = root.querySelectorAll ? root.querySelectorAll(FRAME) : [];

    for (var i = 0; i < frames.length; i += 1) {
      var frame = frames[i];
      var embed = frame.querySelector('.et-video-story__embed');
      if (embed) embed.parentNode.removeChild(embed);

      var player = frame.querySelector('[data-et-video-story-player]');
      if (player) {
        var video = player.querySelector('video');
        if (video) video.pause();
        player.hidden = true;
      }

      frame.removeAttribute(ACTIVE);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest(PLAY);
    if (!button) return;

    event.preventDefault();
    activate(button.closest(FRAME));
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) reset(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target) reset(event.target);
  });
})();
